import { type FC, type ReactNode } from "react";

import { faCircleExclamation } from "@fortawesome/pro-duotone-svg-icons/faCircleExclamation";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// One line under an action that failed, in the field error's style.
export const ErrorLine: FC<{ children: ReactNode }> = ({ children }) => (
  <p className="mt-2 flex items-start gap-1.5 text-xs text-rose-700">
    <FontAwesomeIcon icon={faCircleExclamation} className="mt-0.5" />
    {children}
  </p>
);
